var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { DottedLine, MarkdownContent } from '@shapeable/ui';
import { classNames } from '@shapeable/utils';
var cls = classNames('gpt-generated-content');
export var GptGeneratedContentDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n    color: ", ";\n\n    .visible {\n      animation: fadeIn 1.5s ease-in forwards;\n    }\n    \n    @keyframes fadeIn {\n      from { opacity: 0; }\n      to { opacity: 1; }\n    }\n\n  "], ["\n\n    color: ", ";\n\n    .visible {\n      animation: fadeIn 1.5s ease-in forwards;\n    }\n    \n    @keyframes fadeIn {\n      from { opacity: 0; }\n      to { opacity: 1; }\n    }\n\n  "])), theme.COLOR('text'))
});
var ContentStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n\n    \n\n    padding: ", " 0;\n\n    line-height: 1.65em;\n\n    h1:first-child,\n    h2:first-child,\n    h3:first-child,\n    h4:first-child,\n    h5:first-child,\n    h6:first-child {\n      margin-top: 0;\n    }\n\n  "], ["\n    ", "\n\n    \n\n    padding: ", " 0;\n\n    line-height: 1.65em;\n\n    h1:first-child,\n    h2:first-child,\n    h3:first-child,\n    h4:first-child,\n    h5:first-child,\n    h6:first-child {\n      margin-top: 0;\n    }\n\n  "])), function (_a) {
    var langName = _a.langName;
    return langName && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      direction: ", ";\n\n      & li::before {\n        right: -25px;\n      }\n    "], ["\n      direction: ", ";\n\n      & li::before {\n        right: -25px;\n      }\n    "])), langName === 'Arabic' ? 'rtl' : 'ltr');
  }, theme.UNIT(4))
});
var DottedLineStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Content: styled(MarkdownContent)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  DottedLine: styled(DottedLine)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), DottedLineStyles)
};
export var GptGeneratedContent = function (props) {
  var className = props.className,
    text = props.text,
    children = props.children,
    activeLanguage = props.activeLanguage;
  // const containerRef = useRef(null);
  // useEffect(() => {
  //   const observer = new MutationObserver((mutationsList) => {
  //     for (const mutation of mutationsList) {
  //       if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
  //         mutation.addedNodes.forEach((node) => {
  //           if (node instanceof Element) {
  //             node.classList.add('visible');
  //           }
  //         });
  //       }
  //     }
  //   });
  //   const config = { childList: true, subtree: true };
  //   if (containerRef.current) observer.observe(containerRef.current, config);
  //   return () => observer.disconnect();
  // }, []);
  return (
    // <EmbedComponentsProvider value={{
    //   p: Paragraph,
    // }}>
    React.createElement(My.Container, {
      className: cls.name(className)
    }, React.createElement(My.Content, {
      text: text,
      langName: activeLanguage === null || activeLanguage === void 0 ? void 0 : activeLanguage.name
    }))
    // </EmbedComponentsProvider>
  );
};
GptGeneratedContent.cls = cls;
GptGeneratedContent.defaultProps = GptGeneratedContentDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;